import type { ReactNode } from 'react';

export const symbol_layers_clear: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M779-609q23 17.88 23 46.94T779-515l-109 84q-9 7-19.61 6.31-10.61-.69-18.39-8.31-10-10-9.5-23.5T634-478l108-84-262-204-81 63q-9.14 7-20.57 6t-19.68-9.25q-9.75-9.75-8.6-23.07Q351.29-742.63 362-751l81-63q17-13 37-12.5t37 13.5l262 204Zm30 522L641-255l-124 96q-16.5 13-36.75 13T443-159L151-386q-12-8.94-11.5-23.47T152.08-433q8.3-6 18.11-6 9.81 0 17.81 6l292 227 118-92-55-55h28l-54 42q-17 13-37 13t-37-13L181-515q-23-17.88-23-46.94T181-609l59-47L95-801q-9-9-9-21t9.05-21q9.06-9 21.5-9 12.45 0 21.45 9l714 714q9 9 9 21t-9 21q-9 9-21.5 9T809-87ZM493-572Zm315.46 139.07q11.54 9.1 11.54 23.52Q820-395 809-386l-52 41q-9.14 7-20.57 6T717-348.11q-10-9.59-9-23.24Q709-385 720-393l52-40q8.11-6 18.05-6 9.95 0 18.41 6.07Z"
		/>
	</svg>
);
